import axios from 'axios'
import { normalizeError } from '../utils/error-message'

const Storage = window.localStorage

/**
 * Add a token in the local storage
 * */
function exportTokenToLocalStorage (token) {
  if (Storage) {
    Storage.setItem('loopback-token', JSON.stringify(token))
  }
}

/**
 * Remove token from local storage
 */
function removeTokenFromLocalStorage () {
  if (Storage) {
    Storage.removeItem('loopback-token')
  }
}

function addTokenFromLocalStorage (http) {
  const token = Storage && Storage.getItem('loopback-token')
  if (token) http.setToken(JSON.parse(token), false)
}

const http = axios.create({
  baseURL: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/`
})

// Current setLoading function
let setLoading = () => {
  console.warn('[loopback service] setLoadingFunction is not defined')
}

http.setLoadingFunction = (fn) => {
  setLoading = fn
}

http.getToken = () => {
  const token = Storage && JSON.parse(Storage.getItem('loopback-token'))
  if (token && token.id) return token.id
}

http.setToken = (token, save = true) => {
  http.token = token
  http.defaults.headers.common.Authorization = token.id
  if (save) exportTokenToLocalStorage(token)
}

http.hasToken = () => {
  return http.token !== undefined
}

http.removeToken = () => {
  delete http.defaults.headers.common.Authorization
  delete http.token
  removeTokenFromLocalStorage()
}

http.find = (endpoint, filter) => http.get(endpoint, {params: {filter}})

/* Response Interceptors */
const interceptResErrors = (err) => {
  // TEL-2243: três blocos independentes, e o `setLoading` primeiro de propósito.
  // Este interceptor roda em toda requisição que falha; se a normalização
  // lançasse antes de desligar o loading, o cliente ficaria com o spinner
  // travado — desfecho pior que ver a mensagem técnica. Cada bloco falha
  // sozinho, sem derrubar os outros.
  try {
    setLoading(
      false,
      err.config.uid || err.response.config.uid
    )
  } catch (e) {
    // Will return err if something goes wrong
  }
  try {
    err = Object.assign(new Error(), err)
    if (err.response.data.error) err = Object.assign(err.response.data.error, err)
  } catch (e) {
    // Will return err if something goes wrong
  }
  try {
    // `message` continua intacta: 33 pontos ainda ramificam nela, e ela é o que
    // vai para o log. O que a tela exibe é `friendly`, que nunca contém texto
    // do backend.
    err.friendly = normalizeError(err)
  } catch (e) {
    // Will return err if something goes wrong
  }
  return Promise.reject(err)
}
const interceptResponse = (res) => {
  setLoading(false, res.config.uid)
  try {
    return res.data
  } catch (e) {
    return res
  }
}
http.interceptors.response.use(interceptResponse, interceptResErrors)

// Set storage Token in http if exists
addTokenFromLocalStorage(http)

/* Request Interceptors */
const interceptReqErrors = err => Promise.reject(err)
const interceptRequest = (config) => {
  config.uid = setLoading(true, config.uid)
  return config
}
http.interceptors.request.use(interceptRequest, interceptReqErrors)

export default http

// Documentation: https://github.com/axios/axios



// WEBPACK FOOTER //
// ./src/services/loopback.js